import { AlpineComponent } from '@alpinejs/csp';

const Gallery = (): AlpineComponent => ({
  init() {
    (async () => {
      // @ts-ignore
      const { default: Glide } = await import('@glidejs/glide');

      new Glide(this.$refs.container, {
        type: 'carousel',
        perView: 1,
        gap: 32,
        breakpoints: {
          768: { gap: 0 }
        }
      }).mount();
    })();
  }
});

export default Gallery;
